import React, { useEffect, useState } from 'react';
import { services } from '../services/api';
import Filters from '../components/Filters';
import ServiceTable from '../components/ServiceTable';
import Pagination from '../components/Pagination';

const ServicesPage = ({ user }) => {
  const [serviceData, setServiceData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [filters, setFilters] = useState({});
  const [pagination, setPagination] = useState({
    total: 0,
    last_page: 1,
    per_page: 50,
    current_page: 1,
    from: 0,
    to: 0
  });

  const fetchServices = async (currentFilters = {}, page = 1) => {
    setLoading(true);
    try {
      const params = { ...currentFilters, page, per_page: 50 };
      const response = await services.filter(params);
      setServiceData(response.data.data);
      setPagination(response.data.pagination);
    } catch (err) {
      console.error('Failed to fetch services', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchServices();
  }, []);

  const handleFilterChange = (newFilters) => {
    setFilters(newFilters);
    fetchServices(newFilters, 1);
  };

  const handleExport = async () => {
    setDownloadLoading(true);
    try {
      const response = await services.export(filters);
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `services-export-${new Date().toISOString().split('T')[0]}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (err) {
      console.error('Export failed', err);
      alert('Gagal mengekspor data ke Excel.');
    } finally {
      setDownloadLoading(false);
    }
  };

  const handleDeleteService = async (id) => {
    try {
      await services.delete(id);
      fetchServices(filters);
    } catch (err) {
      console.error('Failed to delete service', err);
      alert(err.response?.data?.message || 'Gagal menghapus servis.');
    }
  };

  return (
    <div className="flex flex-col gap-6">
      {/* Header */}
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
        <div>
          <h2 className="text-2xl font-bold text-gray-900">Log Servis</h2>
          <p className="text-gray-500 text-sm mt-1">Pantau semua aktivitas servis di seluruh AHASS.</p>
        </div>

        <div className="flex flex-wrap items-center gap-4">
          <button
            onClick={handleExport}
            disabled={downloadLoading}
            className={`flex items-center gap-2 ${
              downloadLoading ? 'bg-gray-400 cursor-not-allowed' : 'bg-green-600 hover:bg-green-700'
            } text-white px-4 py-2 rounded-lg text-sm font-bold transition duration-200 shadow-sm`}
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
            {downloadLoading ? 'Mengekspor...' : 'Ekspor ke Excel'}
          </button>

          <div className="bg-blue-100 px-4 py-2 rounded-lg border border-blue-200">
            <p className="text-xs text-blue-600 font-bold uppercase">Total Servis</p>
            <p className="text-xl font-black text-blue-800">{pagination.total}</p>
          </div>
        </div>
      </div>

      <Filters onFilterChange={handleFilterChange} user={user} />
      <ServiceTable data={serviceData} loading={loading} onDelete={handleDeleteService} user={user} />
      
      {!loading && serviceData.length > 0 && (
        <Pagination 
          pagination={pagination} 
          onPageChange={(page) => fetchServices(filters, page)} 
        />
      )}
    </div>
  );
};

export default ServicesPage;
